import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";
import "./styles/home.css";

import mainLogo from "./logo2.png";
import navbarLogo from "./secundario.png";

export default function App() {
  const [language, setLanguage] = useState("en");

  const content = {
    en: {
      navServices: "Services",
      navAbout: "About",
      navContact: "Contact",
      navButton: "Schedule A Call",
      heroEyebrow: "Digital Marketing Agency",
      heroTitle1: "We Turn Ideas Into",
      heroTitle2: "Campaigns",
      heroTitle3: "That Sell",
      heroDescription:
        "At Matneu Investment, we create high-performance marketing systems that combine strategy, advertising, content creation, and automation to accelerate business growth.",
      heroButton1: "Schedule A Call",
      heroButton2: "View Services",
      heroCardTitle: "Growth Driven Marketing",
      heroCardDescription:
        "Data, creativity and execution working together to generate measurable results.",
      strategy: "Digital Strategy",
      results: "ROI Focused",
      servicesTitle: "What We Do",
      growthEyebrow: "Why Choose Us",
      growthTitle1: "Marketing That",
      growthTitle2: "Actually Performs",
      growthDescription:
        "We combine paid traffic, content production, web design, automation and analytics to help brands scale faster.",
      features: [
        "Performance focused campaigns",
        "Creative content production",
        "Modern web experiences",
        "Automation & lead generation",
      ],
      ctaTitle: "Ready To Grow Your Brand?",
      ctaDescription:
        "Let's build a marketing strategy tailored to your business goals.",
      ctaButton: "Contact Us",
      footer:
        "Digital marketing, advertising and growth strategies designed to scale modern businesses.",
    },

    es: {
      navServices: "Servicios",
      navAbout: "Nosotros",
      navContact: "Contacto",
      navButton: "Agendar Llamada",
      heroEyebrow: "Agencia de Marketing Digital",
      heroTitle1: "Convertimos Ideas En",
      heroTitle2: "Campañas",
      heroTitle3: "Que Venden",
      heroDescription:
        "En Matneu Investment creamos sistemas de marketing de alto rendimiento combinando estrategia, publicidad, contenido y automatización para acelerar el crecimiento de tu negocio.",
      heroButton1: "Agendar Llamada",
      heroButton2: "Ver Servicios",
      heroCardTitle: "Marketing Orientado Al Crecimiento",
      heroCardDescription:
        "Datos, creatividad y ejecución trabajando juntos para generar resultados medibles.",
      strategy: "Estrategia Digital",
      results: "Enfoque ROI",
      servicesTitle: "Lo Que Hacemos",
      growthEyebrow: "Por Qué Elegirnos",
      growthTitle1: "Marketing Que",
      growthTitle2: "Realmente Funciona",
      growthDescription:
        "Combinamos tráfico pago, producción de contenido, diseño web, automatización y analítica para ayudar a las marcas a crecer.",
      features: [
        "Campañas orientadas a resultados",
        "Producción de contenido premium",
        "Experiencias web modernas",
        "Automatización y generación de leads",
      ],
      ctaTitle: "¿Listo Para Impulsar Tu Marca?",
      ctaDescription:
        "Construyamos una estrategia de marketing diseñada para tus objetivos.",
      ctaButton: "Contáctanos",
      footer:
        "Marketing digital, publicidad y estrategias de crecimiento diseñadas para escalar negocios modernos.",
    },
  };

  const t = content[language];

  const layoutProps = {
    t,
    language,
    setLanguage,
    mainLogo,
    navbarLogo,
  };

  return (
    <BrowserRouter>
        <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Layout {...layoutProps}>
              <Home {...layoutProps} />
            </Layout>
          }
        />

        <Route
          path="/services/:slug"
          element={
            <Layout {...layoutProps}>
              <ServicePage {...layoutProps} />
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}